import { css } from 'lit';

export const pimsterGalleryWidgetStyle = css`
  :host {
    flex-grow: 1;
  }

  .iframe {
    border: none;
    width: 100%;
  }
`;
